export var CheckpointSource;
(function (CheckpointSource) {
    CheckpointSource["Statement"] = "STATEMENT";
    CheckpointSource["User"] = "USER";
})(CheckpointSource || (CheckpointSource = {}));
//# sourceMappingURL=checkpoint-source.enum.js.map